import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const KEY_ICON_SIZE = 16;

const ProductListKeyItem = ({
  icon: Icon,
  title,
  message = '',
  iconGreen = false
}) => (
  <div className="d-flex mb-2 mb-0--last">
    <div className="me-2">
      <Icon
        className={`d-block u-fill-icon--${
          iconGreen ? 'MediumGreen' : 'DarkGray'
        }`}
        height={KEY_ICON_SIZE}
        width={KEY_ICON_SIZE}
      />
    </div>
    <div>
      <h4
        className={`h4 text-xs text-capitalize mb-0 color-extra-dark-gray text-sans-serif fw-bold
          ${styles['key-section__icon']}`}
      >
        {title}
      </h4>
      {message}
    </div>
  </div>
);

ProductListKeyItem.propTypes = {
  icon: PropTypes.string.isRequired,
  iconGreen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  message: PropTypes.node
};

export default ProductListKeyItem;
